<div class="at-a-glance-section">
  <ssg-expander [open]="allExpanded || sectionExpanded" (stateChanged)="sectionExpanded = $event" [expandable]="!noCollections">
    <div expander-content>
      <div class="at-a-glance-section-header" data-automation="at-a-glance-collections-header">
        <div class="header-position">
        <ukg-popover #collectionsTooltip class="at-a-glance-tooltip" type="custom">
          <span>
            <b><span translate [translateParams]="{ title: ('AT_A_GLANCE.PANEL_TITLE' | translate)  }">AT_A_GLANCE.COLLECTION_HEADER</span></b> <br/><br />
            <p *ngIf="!isApiForNettedCollectionsEnabled" [innerHtml]=" 'AT_A_GLANCE.COLLECTIONS_HELP_TEXT' | translate "></p>
            <p *ngIf="isApiForNettedCollectionsEnabled" [innerHtml]=" 'AT_A_GLANCE.COLLECTIONS_NET_HELP_TEXT' | translate "></p>
          </span>
        </ukg-popover>
        <strong class="section-title" translate>COMMON.COLLECTIONS</strong>
        <ukg-icon (click)="collectionsTooltip.present($event.target)" name="help" class="heading-icon-spacing"></ukg-icon>
        <ukg-popover #nettedTooltip class="at-a-glance-tooltip" type="custom">
          <span>
            <p [innerHtml]=" 'AT_A_GLANCE.COLLECTION_NETTED' | translate "></p>
          </span>
        </ukg-popover>
      </div>
      </div>
    </div>
    <div expanded-content>
      <div *ngIf="!noCollections">
        <div *ngFor="let statusIndex of statusOrder">
          <div *ngFor="let collection of collections[statusIndex]" class='at-a-glance-item at-a-glance-collection-group-{{statusIndex}}'>
            <ng-template #expectedProcessDateRow class="at-a-glance-tooltip" type="custom">
              <div class="flex-row" *ngIf="!(collection.processUtcDate | isMinDate)">
                <div class="flex-70"><ukg-label translate>AT_A_GLANCE.EXPECTED_PROCESS_DATE</ukg-label></div>
                <div class="flex-30 text-right">{{collection.processUtcDate | amFromUtc | amDateFormat:
                  'MM/DD/YY'}}
                </div>
              </div>
            </ng-template>
            <ukg-popover #collectionTooltip type="custom">
              <div class="collection-tooltip">
                <div><strong>{{collection.name}}</strong></div>
                <br>
                <div class="flex-row" *ngIf="collection.status !== CollectionStatus.PartiallyCollected">
                  <div *ngIf="!isApiForNettedCollectionsEnabled" class="flex-50"><ukg-label translate>AT_A_GLANCE.COLLECTION_AMOUNT</ukg-label></div>
                  <div *ngIf="isApiForNettedCollectionsEnabled" class="flex-50"><ukg-label translate>AT_A_GLANCE.COLLECTION_NET_AMOUNT</ukg-label></div>
                  <ssg-currency class="flex-50" [ngClass]="getCurrencyStyleClass(collection.status)"
                                [showFullAmount]="true" [amount]="collection.totalNettedAmount"></ssg-currency>
                </div>
                <div class="flex-row">
                  <div class="flex-75"><ukg-label translate>AT_A_GLANCE.BANK_ACCOUNT_LAST_4_DIGITS</ukg-label></div>
                  <div class="flex-25 text-right">{{collection.maskedAccountNumber}}</div>
                </div>
                <div class="flex-row" *ngIf="collection.status">
                  <div class="flex-70"><ukg-label translate>AT_A_GLANCE.COLLECTION_STATUS</ukg-label></div>
                  <div class="flex-30 text-right" [ngSwitch]="collection.status">
                    <span *ngSwitchCase="CollectionStatus.Created" translate>COMMON.PENDING</span>
                    <span *ngSwitchCase="CollectionStatus.InTransit" translate>COMMON.PROCESSING</span>
                    <span *ngSwitchDefault>{{ collection.status | enum:'CollectionStatus' }}</span>
                  </div>
                </div>
                <div [ngSwitch]="collection.status">
                  <div *ngSwitchCase="CollectionStatus.Collected">
                    <div class="flex-row" *ngIf="!(collection.collectedUtcDt | isMinDate)">
                      <div class="flex-70"><ukg-label translate>AT_A_GLANCE.DATE_MARKED_COLLECTED</ukg-label></div>
                      <div class="flex-30 text-right">{{collection.collectedUtcDt | amFromUtc | amDateFormat:
                        'MM/DD/YY'}}
                      </div>
                    </div>
                  </div>
                  <div class="flex-gap-10" *ngSwitchCase="CollectionStatus.PartiallyCollected">
                    <div>
                      <div class="flex-gap-10"><ukg-label translate>AT_A_GLANCE.AMOUNTS</ukg-label></div>
                      <div class="collection-tooltip-partially-collected-amounts">
                        <div class="flex-row">
                          <div class="flex-50"><ukg-label translate>AT_A_GLANCE.AMOUNT_TOTAL</ukg-label></div>
                          <ssg-currency class="flex-50" [showFullAmount]="true"
                                        [amount]="collection.totalNettedAmount"></ssg-currency>
                        </div>
                        <div class="flex-row">
                          <div class="flex-50"><ukg-label translate>AT_A_GLANCE.AMOUNT_RECEIVED</ukg-label></div>
                          <ssg-currency class="flex-50" [showFullAmount]="true"
                                        [amount]="collection.collectedAmount"></ssg-currency>
                        </div>
                        <div class="flex-row">
                          <div class="flex-50"><ukg-label translate>AT_A_GLANCE.AMOUNT_REMAINING</ukg-label></div>
                          <ssg-currency class="flex-50" [showFullAmount]="true"
                                        [amount]="collection.totalNettedAmount - collection.collectedAmount"></ssg-currency>
                        </div>
                      </div>
                        <ng-container *ngTemplateOutlet="expectedProcessDateRow"></ng-container>
                    </div>
                  </div>
                  <div *ngSwitchDefault>
                    <ng-container *ngTemplateOutlet="expectedProcessDateRow"></ng-container>
                  </div>
                </div>
                <div class="flex-row">
                  <div class="flex-60"><ukg-label translate>AT_A_GLANCE.COLLECTION_METHOD</ukg-label></div>
                  <div class="flex-40 text-right">{{ collection.paymentMethod | enum:'PaymentMethod' }}</div>
                </div>
                <div *ngIf="collection.status === CollectionStatus.Returned" class="flex-gap-10">
                  <div class="flex-row bank-note">
                    <div translate>AT_A_GLANCE.RETURNED_BY_BANK_NOTE</div>
                  </div>
                </div>
              </div>
            </ukg-popover>
            <ukg-popover #collectionStatusTooltip type="custom">
              <div class="collection-tooltip" [ngSwitch]="collection.status">
                <span *ngSwitchCase="[CollectionStatus.Unknown, CollectionStatus.Combined].includes(collection.status) ? collection.status : -1">
                  {{ 'AT_A_GLANCE.COLLECTION_STATUS_INVALID_HELP_TEXT' | translate }}
                </span>
                <span *ngSwitchDefault>
                  {{ ('AT_A_GLANCE.COLLECTION_STATUS_'+CollectionStatus[collection.status].split('
                  ').join('').toUpperCase()+'_HELP_TEXT') | translate }}
                </span>
              </div>
            </ukg-popover>
            <ukg-popover #collectionAmountTooltip type="custom">
              <div class="collection-tooltip">
                <div class="flex-row">
                  <strong class="flex-60" [attr.data-automation]="'at-a-glance-collections-net-label'+statusIndex"
                    translate>AT_A_GLANCE.COLLECTION_NET_AMOUNT</strong>
                  <strong class="flex-40">
                    <ssg-currency [attr.data-automation]="'at-a-glance-collections-net-amount'+statusIndex"
                      [ngClass]="getCurrencyStyleClass(collection.status)" [showFullAmount]="true"
                      [amount]="collection.status !== CollectionStatus.PartiallyCollected ? collection.totalNettedAmount : collection.collectedAmount">
                    </ssg-currency>
                  </strong>
                </div>
                <br>
                <div class="flex-row collection-tooltip-net-amounts">
                  <div class="flex-50"><ukg-label translate [attr.data-automation]="'at-a-glance-collections-original-label'+statusIndex">AT_A_GLANCE.COLLECTION_ORIGINAL_AMOUNT</ukg-label></div>
                  <ssg-currency [attr.data-automation]="'at-a-glance-collections-original-amount'+statusIndex" class="flex-50" [ngClass]="getCurrencyStyleClass(collection.status)" [showFullAmount]="true" [amount]="collection.includedNettedAmount"></ssg-currency>
                </div>
                <div class="flex-row collection-tooltip-net-amounts" *ngIf="collection.nettedCollectionCount > 1">
                  <div class="flex-50"><ukg-label translate data-automation="at-a-glance-collections-other-label">AT_A_GLANCE.COLLECTION_OTHER_PAY_PERIOD_AMOUNT</ukg-label></div>
                  <ssg-currency data-automation="at-a-glance-collections-other-amount" class="flex-50" [ngClass]="getCurrencyStyleClass(collection.status)" [showFullAmount]="true" [amount]="collection.excludedNettedAmount"></ssg-currency>
                </div>
                <div class="flex-row collection-tooltip-net-amounts" *ngIf="collection.nettedCollectionCount > 1 && collection.achCreditRefundedAmount !== 0">
                  <div class="flex-50"><ukg-label translate data-automation="at-a-glance-collections-refund-label">AT_A_GLANCE.COLLECTION_ACH_CREDIT_REFUNDED</ukg-label></div>
                  <ssg-currency data-automation="at-a-glance-collections-refund-amount" class="flex-50" [ngClass]="getCurrencyStyleClass(collection.status)" [showFullAmount]="true" [amount]="collection.achCreditRefundedAmount"></ssg-currency>
                </div>
              </div>
            </ukg-popover>
            <div class="at-a-glance-row flex-row">
              <div class="flex-60">
                <span class="collection-name help-cursor-hover section-title" (click)="collectionTooltip.present($event.target)"  data-automation="at-a-glance-collections-bank">{{collection.name}}</span>
                <br>
                <span [ngSwitch]="collection.status" class="section-metadata help-cursor-hover" style="display: inline-block" (click)="collectionStatusTooltip.present($event.target)" data-automation="at-a-glance-collections-status">
                  <div *ngSwitchCase="CollectionStatus.Collected">
                    <span class="header-position" *ngIf="!(collection.collectedUtcDt | isMinDate)">
                      <ukg-icon name="status-finished" class="check-circle" size="s"></ukg-icon>
                      {{ 'AT_A_GLANCE.COLLECTED_ON' | translate:{date: collection.collectedUtcDt | amFromUtc |
                      amDateFormat: 'MM/DD' } }}
                    </span>
                  </div>
                  <div *ngSwitchCase="CollectionStatus.Ready">
                    <span *ngIf="!(collection.processUtcDate | isMinDate)">
                        {{ 'AT_A_GLANCE.EXPECTED_PROCESS_DATE' | translate}} {{collection.processUtcDate | amFromUtc | amDateFormat: 'MM/DD' }}
                    </span>
                  </div>
                  <span *ngSwitchCase="CollectionStatus.InTransit" translate>COMMON.PROCESSING</span>
                  <span *ngSwitchCase="[CollectionStatus.Created, CollectionStatus.Pending].includes(collection.status) ? collection.status : -1">
                    {{ collection.status | enum:'CollectionStatus'}}
                  </span>
                  <span class="header-position text-warning" *ngSwitchCase="[CollectionStatus.OnHold, CollectionStatus.PartiallyCollected, CollectionStatus.Voided, CollectionStatus.Returned].includes(collection.status) ? collection.status : -1">
                    <ukg-icon color="warning" name="warning" size="s"></ukg-icon>
                    {{ collection.status | enum:'CollectionStatus'}}
                  </span>
                  <span class="header-position text-danger" *ngSwitchDefault>
                    <ukg-icon color="important" name="warning" size="s"></ukg-icon>
                    {{ collection.status | enum:'CollectionStatus'}}
                  </span>
                </span>
              </div>
              <div class="flex-40">
                <div class="collection-total-container section-title">
                  <ukg-popover #nettingCollection translate>AT_A_GLANCE.NETTING_TOOLTIP</ukg-popover>
                  <ukg-icon name="link" size="s" *ngIf="collection.nettedCollectionCount > 1" (click)="nettingCollection.present($event.target)" data-automation="at-a-glance-collections-netting-tooltip"></ukg-icon>
                  <ssg-currency *ngIf="!isApiForNettedCollectionsEnabled" container="body" placement="right"
                                inline="true"
                                [ngClass]="getCurrencyStyleClass(collection.status)"
                                [amount]="collection.totalAmount" [showFullAmount]="true"  data-automation="at-a-glance-collections-total"></ssg-currency>
                  <ssg-currency *ngIf="isApiForNettedCollectionsEnabled" class="help-cursor-hover"
                                inline="true"
                                [ngClass]="getCurrencyStyleClass(collection.status)"
                                [amount]="collection.status !== CollectionStatus.PartiallyCollected ? collection.totalNettedAmount : collection.collectedAmount" [showFullAmount]="true"
                                (click)="collectionAmountTooltip.present($event.target)"  data-automation="at-a-glance-collections-total"></ssg-currency>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ssg-expander>
  <div *ngIf="noCollections" class="text-muted text-center text-sm text-no-data" data-automation="at-a-glance-collection-no-data-display">
    <i translate>AT_A_GLANCE.NO_COLLECTIONS</i>
  </div>
</div>